export default "__VITE_ASSET__DlMaM3gu__"